import React from 'react';
import { Tag, Space } from 'antd';

const { CheckableTag } = Tag as any;

export interface SubServiceOption {
  value: string;
  label: string;
}

interface SubServiceFilterProps {
  options: SubServiceOption[];
  value: string;
  onChange: (val: string) => void;
}

const SubServiceFilter: React.FC<SubServiceFilterProps> = ({ options, value, onChange }) => {
  if (!options || options.length === 0) return null;
  return (
    <div style={{ marginBottom: 12 }}>
      <Space wrap size={[0, 8]}>
        <CheckableTag
          key="_all"
          checked={!value}
          onChange={() => onChange('')}
          style={{ padding: '4px 10px', border: '1px solid #d9d9d9', borderRadius: 4 }}
        >
          全部
        </CheckableTag>
        {options.map((opt) => (
          <CheckableTag
            key={opt.value}
            checked={value === opt.value}
            onChange={() => onChange(opt.value)}
            style={{ padding: '4px 10px', border: '1px solid #d9d9d9', borderRadius: 4 }}
          >
            {opt.label}
          </CheckableTag>
        ))}
      </Space>
    </div>
  );
};

export default SubServiceFilter;

